import { BodyLong } from '@navikt/ds-react'
import styled from 'styled-components'
import { WidgetProps, WidgetTemplate } from 'index.d'
import { WidgetPropType } from 'index.pt'
import PT from 'prop-types'
import React, { useEffect, useState } from 'react'
import ReactResizeDetector from 'react-resize-detector'
import SmileyOptionsWidget from './SmileyOptionsWidget'

const SmileyWidgetDiv = styled.div`
  text-align: center;
  padding: 1rem;
  background-color: var(--navds-color-background); 
  color: var(--navds-color-text-primary);
`

const SmileyWidget = ({ onResize, widget }: WidgetProps) => {
  const [mounted, setMounted] = useState<boolean>(false)

  useEffect(() => {
    if (!mounted && onResize) {
      onResize()
      setMounted(true)
    }
  }, [mounted, onResize])

  return (

    <SmileyWidgetDiv className='w-SmileyWidget'>
      <ReactResizeDetector
        handleWidth
        handleHeight
        onResize={onResize}
      />
      <BodyLong>
        Today's mood
      </BodyLong>
      <p style={{
        fontSize: '100px',
        margin: '0px'
      }}
      >
        <span className='w-SmileyWidget__smiley' role='img' aria-label='smiley'>
          {widget.options.mood}
        </span>
      </p>
    </SmileyWidgetDiv>
  )
}

const properties: WidgetTemplate = {
  type: 'smiley',
  title: 'Smiley widget',
  description: 'Widget with a 😁',
  layout: {
    lg: { minW: 2, maxW: 4, defaultW: 2, minH: 6, defaultH: 6, maxH: 999 },
    md: { minW: 1, maxW: 3, defaultW: 1, minH: 6, defaultH: 6, maxH: 999 },
    sm: { minW: 1, maxW: 1, defaultW: 1, minH: 6, defaultH: 6, maxH: 999 }
  },
  options: {
    backgroundColor: 'white',
    mood: '😁',
    availableMoods: [
      { label: 'grin', value: '😁' },
      { label: 'happy', value: '😃' },
      { label: 'smiling', value: '😊' },
      { label: 'unamused', value: '😒' },
      { label: 'angry', value: '😠' },
      { label: 'pouting', value: '😡' }
    ]
  }
}

SmileyWidget.properties = properties
SmileyWidget.Edit = SmileyOptionsWidget

SmileyWidget.propTypes = {
  onResize: PT.func.isRequired,
  widget: WidgetPropType.isRequired
}

export default SmileyWidget
